import { type CommonTranslationFunction } from '@autone/translations';

export function formatDatasetAge(
  ageDays: number | null,
  locale = navigator.language,
  common: CommonTranslationFunction,
): string {
  if (ageDays === null) {
    return common('na');
  }

  if (ageDays === 0) {
    return common('data-age.global-widget.today');
  }

  const formatted = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'day',
    unitDisplay: 'narrow',
  }).format(ageDays);

  return common('data-age.global-widget.ago', { value: formatted });
}
